













import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Action } from "vuex-class";
import anime from "animejs";
import Button from "./Button.vue";
import TelephoneNumbers from "./TelephoneNumbers.vue";
import SocialLinks from "./SocialLinks.vue";
import constants from '../store/constants';

@Component({
  components: {
    Button,
    TelephoneNumbers,
    SocialLinks
  }
})
export default class ContactsBlock extends Vue {
  // Ссылки на глобальное состояние
  @State(state => state.app.loadingScreenActive) loadingScreenActive!: number;

  $refs!: {
    button: Button;
    socialLinks: Vue;
    telephoneNumbers: Vue;
  };

  // Запускаем анимацию на исчезновении экрана загрузки
  @Watch("loadingScreenActive")
  onLoadingScreenHide() {
    this.enteringAnimation(400);
  }

  /**
   * Анимация появления содержимого
   * @param {number} delayTime Задержка перед запуском анимации
   */
  enteringAnimation(delayTime: number = 0) {
    let telephoneNumbers = this.$refs.telephoneNumbers.$el.querySelectorAll(".telephone");
    var tl = anime.timeline();

    tl.add(
      {
        targets: telephoneNumbers,
        duration: 1000,
        left: ["110%", "0%"],
        easing: "easeOutCubic",
        delay: (item, i) => {
          return delayTime + (170 * i);
        }
      }
    );

    // Запускаем анимацию кнопки
    tl.add({
      targets: this.$refs.button.$el,
      duration: 1000,
      left: ["110%", "0%"],
      easing: "easeOutCubic"
    }, "-=800");

    tl.add(
      {
        targets: this.$refs.socialLinks.$el,
        duration: 1000,
        left: ["117%", "0%"],
        easing: "easeOutCubic"
      },
      "-=900"
    );
  }

  mounted() { }

  openContactWindow() {
    window.dispatchEvent(new Event("openForm:singUpForViewing"));
  }
}
